// extracted by mini-css-extract-plugin
export default {"skeleton":"M1cUg6","dissolve":"IrgdLE"};